import React, { ReactNode } from 'react';
import { ErrorsMap, FormService } from 'shared/libs/form';
import { PersonalInfoSchema } from './personal-info.validator';

export type PersonalInfoValue = {
    name: string;
    lastName: string;
    middleName: string;
    birthDate: string;
    gender: string;
    country: string;
    city: {
        value: number;
        label: string;
    } | null;
};

type SetFn = <K extends keyof PersonalInfoValue>(key: K, value: PersonalInfoValue[K]) => void;

type PersonalInfoContextValue = {
    value: PersonalInfoValue;
    valid: boolean;
    errors: ErrorsMap<PersonalInfoValue>;
    set: SetFn;
    initValue: (v: any) => void;
};

const PersonalInfoContext = React.createContext<PersonalInfoContextValue | undefined>(
    undefined
);

export const PersonalInfoProvider = ({ children }: { children: ReactNode }) => {
    const [state, setState] = React.useState({
        name: '',
        lastName: '',
        middleName: '',
        birthDate: '',
        gender: '',
        country: '',
        city: null,
    });

    const set: SetFn = (key, value) => {
        setState((prev) => ({
            ...prev,
            [key]: value,
        }));
    };

    const validation = FormService.validate<PersonalInfoValue>(state, PersonalInfoSchema);

    return (
        <PersonalInfoContext.Provider
            value={{
                value: state,
                errors: validation.errorsMap,
                set,
                valid: validation.valid,
                initValue: () => {},
            }}
        >
            {children}
        </PersonalInfoContext.Provider>
    );
};
export const usePersonalInfo = () => {
    const ctx = React.useContext(PersonalInfoContext);
    if (!ctx) {
        throw new Error('usePersonalInfo must be used inside PersonalInfoProvider');
    }
    return ctx;
};
